import { HEADER_APP_IDENTIFIER } from "../../consts/HEADER_APP_IDENTIFIER";

import { headerInterceptorFactory } from "./headerInterceptor";

export const appIdentifierInterceptorFactory = (appIdentifier: string) =>
  headerInterceptorFactory({
    header: HEADER_APP_IDENTIFIER,
    value: appIdentifier,
  });
